import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FeaturedNewsCard = ({ news }) => {
  const getCategoryColor = (category) => {
    const colors = {
      hr: 'var(--color-info)',
      payroll: 'var(--color-success)',
      tax: 'var(--color-warning)',
      minimum_wage: 'var(--color-error)',
      employment_act: 'var(--color-primary)',
      gazette: 'var(--color-accent)',
      general: 'var(--color-muted-foreground)'
    };
    return colors?.[category] || 'var(--color-muted-foreground)';
  };

  const getCategoryLabel = (category) => {
    const labels = {
      hr: 'HR & Employment',
      payroll: 'Payroll',
      tax: 'Tax (SWT)',
      minimum_wage: 'Minimum Wage',
      employment_act: 'Employment Act',
      gazette: 'Gazette',
      general: 'General'
    };
    return labels?.[category] || category;
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString)?.toLocaleDateString('en-PG', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  return (
    <div className="bg-gradient-to-br from-primary/10 to-accent/10 border-2 border-primary/20 rounded-lg p-6 transition-smooth hover:shadow-lg relative overflow-hidden">
      {/* Featured Badge */}
      <div className="absolute top-4 right-4">
        <div className="flex items-center gap-1 px-3 py-1 bg-warning text-warning-foreground rounded-full text-xs font-bold">
          <Icon name="Star" size={12} color="currentColor" />
          FEATURED
        </div>
      </div>

      {/* Category Badge */}
      <div className="mb-3">
        <div
          className="inline-flex items-center gap-1 px-3 py-1 rounded-md text-xs font-medium"
          style={{ backgroundColor: `${getCategoryColor(news?.category)}15`, color: getCategoryColor(news?.category) }}
        >
          {getCategoryLabel(news?.category)}
        </div>
      </div>

      {/* Title */}
      <h3 className="text-lg font-heading font-bold text-foreground mb-3 line-clamp-2">
        {news?.title}
      </h3>

      {/* Summary */}
      <p className="text-sm text-muted-foreground mb-4 line-clamp-3">
        {news?.summary}
      </p>

      {/* Metadata */}
      <div className="flex flex-col gap-2 text-xs text-muted-foreground mb-4">
        <div className="flex items-center gap-1">
          <Icon name="Calendar" size={12} color="currentColor" />
          <span>{formatDate(news?.publicationDate)}</span>
        </div>
        {news?.effectiveDate && (
          <div className="flex items-center gap-1">
            <Icon name="Clock" size={12} color="currentColor" />
            <span>Effective: {formatDate(news?.effectiveDate)}</span>
          </div>
        )}
        {news?.gazetteReference && (
          <div className="flex items-center gap-1">
            <Icon name="FileText" size={12} color="currentColor" />
            <span>{news?.gazetteReference}</span>
          </div>
        )}
      </div>

      {/* Action */}
      <Button
        variant="primary"
        size="sm"
        fullWidth
        iconName="ArrowRight"
        iconPosition="right"
      >
        Read More
      </Button>
    </div>
  );
};

export default FeaturedNewsCard;